<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">공지사항 신규 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span class="emp">제목</span></th>
                  <td><input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.boardNoticeTitle"></td>
                </tr>
                <tr>
                  <th><span>중요공지</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_checkbox" style="min-width:auto">
                          <input type="checkbox" id="'checkbox'" name="checkbox" true-value="Y" v-model="regData.boardNoticeImptYn">
                          <label for="'checkbox'"></label>
                      </div>
                      <small class="txt_info"> &#8251; 체크시 목록 상위에 보여집니다.</small>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">공지기간</span></th>
                  <td> 
                    <div class="form_inline">
                      <Datepicker  v-model="regData.boardNoticeStartDt" :defaultDate="regData.boardNoticeStartDt" :format="'YYYY-MM-DD'"/>
                      <span>~</span>
                      <Datepicker  v-model="regData.boardNoticeEndDt" :defaultDate="regData.boardNoticeEndDt" :format="'YYYY-MM-DD'"/>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">게시여부</span></th>
                  <td>
                      <div class="form_inline">
                        <div class="form_radio">
                          <input type="radio" id="radio3" name="radio" value="I" checked v-model="regData.noticeStatus">
                          <label for="radio3">게시</label>
                        </div>
                        <div class="form_radio">
                          <input type="radio" id="radio4" name="radio" value="U" v-model="regData.noticeStatus">
                          <label for="radio4">미게시</label>
                        </div>
                      </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">내용</span></th>
                  <td>
                    <small class="txt_info d-block mb-1">&#8251; 이미지는 10M 이하만 가능합니다.</small>
                    <Editor :content="regData.boardNoticeCnts" @getContents="fn_get_contents" />
                  </td>
                </tr>
                <tr>
                  <th><span>첨부파일</span></th>
                  <td>
                    <div class="form_inline">
                      <button class="btn btn_md btn_blue" @click="fn_noticeFileUpload">파일업로드</button>
                      <input type="file" ref="noticeFile" @change="fn_fileNoticeChange" hidden>
                      <ul class="file_list" v-if="regData.noticeFileNm != ''">
                        <li><a href="" download="">{{regData.noticeFileNm}}</a></li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- <button class="btn btn_md btn_gray" @click="fn_move_page">취소</button> -->
                <button class="btn btn_md btn_darkblue" @click="fn_notice_reg">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
	import axios from 'axios'
    import Datepicker from '@/components/Datepicker.vue'
    import commonUtil from "@/mixin/commonUtil";
    import Editor from "@/components/common/Editor.vue"

	export default {
		name: 'NoticeMngtReg',
		components: {
		    Datepicker,
        Editor
		},
        mixins: [commonUtil],
		data() {
            return {
                selected: null,
                regData : {
                    boardNoticeId : "",
                    boardNoticeTitle : "",
                    boardNoticeImptYn : "",                    
                    boardNoticeCnts : "",
                    boardNoticeFileId : "",
                    boardNoticeStartDt : "",
                    boardNoticeEndDt : "",
                    noticeStatus : "I",                    
                    noticeFileNm : "",
                    status : ''
                },
                upLoadFile : {
                    upFile : ''
                }
		    }
		},
        created() {
          this.boardNoticeId = this.$store.getters['notice/getBoardNoticeId'];
          console.log("@@@@ boardNoticeId : "+this.boardNoticeId);
          if(this.boardNoticeId !== ''){
            this.regData.status = 'M'
            this.fn_search(this.boardNoticeId);
          }
        },
        methods : {
            fn_move_page(){
                this.$router.push("/admin/board/noticeMngt");
            },
            fn_noticeFileUpload(){
                let fileInputElement = this.$refs.noticeFile;
                fileInputElement.click();
            },
            fn_fileNoticeChange(e){
                this.upLoadFile.upFile = e.target.files[0];
                this.regData.noticeFileNm = this.upLoadFile.upFile.name;
            },
            fn_notice_reg(){

                if(!this.regValidation()) return;
                console.log("@@@@ this.regData : %o",this.regData);

                var frm = new FormData();
   
                frm.append("file",this.upLoadFile.upFile);
                frm.append("key",JSON.stringify(this.regData));

               axios
                    .post("/api/admin/board/regNotice", frm, {
                            "Content-Type": "multipart/form-data",
                            "Accept-Language" : "ko"})
                    .then((res) => {                            
                        console.log("@@@@ res : %o",res);

                        alert("저장되었습니다");
                        this.fn_move_page();
                        
                    })
                    .catch((err) => console.log(err));


            },
            fn_get_contents(contents){                
                this.regData.boardNoticeCnts = contents;
            },
            regValidation(){

                if(this.regData.boardNoticeTitle == ''){
                    alert("제목을 입력해주세요");
                    return false;
                }

                if(this.regData.boardNoticeStartDt == "" || this.regData.boardNoticeEndDt == ""){
                    alert("날짜를 입력해주세요");
                    return false;
                }else if(this.regData.boardNoticeStartDt > this.regData.boardNoticeEndDt){
                    alert("잘못된 날짜입니다");
                    return false;
                }

                if(this.regData.boardNoticeCnts == "" ){
                    alert("내용를 입력해주세요");
                    return false;
                }

                return true;
            },
            fn_search(boardNoticeId){

              let param = new Object();
              param.boardNoticeId = boardNoticeId;

              console.log("@@@@ param : %o",param);

              axios
                  .post("/api/admin/board/noticeDetail", param)
                  .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.noticeInfo = res.data;

                    this.regData.boardNoticeId = res.data.board_notice_id,
                    this.regData.boardNoticeTitle = res.data.board_notice_title,
                    this.regData.boardNoticeImptYn = res.data.board_notice_impt_yn,
                    this.regData.boardNoticeCnts  = res.data.board_notice_cnts,
                    this.regData.boardNoticeFileId = res.data.file_id,
                    this.regData.boardNoticeStartDt = res.data.board_notice_start_dt,
                    this.regData.boardNoticeEndDt = res.data.board_notice_end_dt,
                    this.regData.noticeStatus = res.data.board_notice_status,
                    this.regData.noticeFileNm = res.data.file_org_name

                    console.log("@@@@ noticeInfo : %o",this.noticeInfo);
                  })
                  .catch((err) => console.log(err));

            },
        }
    }
    
</script>